// extracted by mini-css-extract-plugin
export default {"title":"M757s2tqDCMKxthOKfbw","card":"yfXk3TL8tN1If6hiariw"};